import { Link } from "react-router-dom";

const Header = () => {
	return (
		<nav className="bg-secondary text-red-900 h-[80px] flex justify-around items-center shadow-md font-bold">
			<div className="absolute left-1 lg:left-10 top-0 items-center hidden md:flex">
				<img
					src="asset/icepyramid.png"
					alt="ICEPyramid Logo"
					className="w-[60px] mx-auto mt-4"
				/>
			</div>

			<Link className="hover:text-red-600 text-xl" to="/">
				Home
			</Link>
			<Link className="hover:text-red-600 text-xl" to="/services">
				Services
			</Link>
			<Link className="hover:text-red-600 text-xl" to="/about">
				About
			</Link>
			<Link className="hover:text-red-600 text-xl" to="/contact">
				Contact
			</Link>
		</nav>
	);
};

export default Header;
